module.exports = __webpack_public_path__ + "images/emoji/corn.c0cf0b023a851a69c118.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/corn.png
// module id = JsgM
// module chunks = 13